import React from "react";
import ProductsList from "./inc/ProductsList";


function Products(){

return (

<div>
<section className="py-4 bg-light title">

   <div className="container">
     <div className="row">
        <div className="col-md-4 my-auto">
        <h3 className="float-end"> محصولات  </h3>
        </div>

      </div>
     </div>

</section>




<section className="section border-bottom">
  <div className="container">
  <h5 className="main-heading">نسخه های مختلف سیستم یکپارچه مالی راینو</h5>
  <div className="underline"></div>

  <ProductsList/>

  </div>

</section>


</div>


    )

}




export default Products;